<template>
  <div class="card-input-form">
    <!-- Card Header -->
    <div class="card-header">
      <h3 class="card-title">{{ title }}</h3>
    </div>

    <!-- Card Body -->
    <div class="card-body">
      <div class="form-grid">
        <div v-for="field in fields" :key="field.name" class="form-row">
          <!-- Label Column -->
          <label :for="field.name" class="form-label" :class="{ 'label-required': field.required }">
            {{ field.label }}
          </label>

          <!-- Field Column -->
          <div class="form-field">
            <div class="form-editor" v-if="!field.readonly || field.disabled">
              <slot :name="`field-${field.name}`" :field="field" :value="modelValue[field.name]"
                :disabled="field.disabled" />
            </div>

            <div v-else class="form-display">
              <slot :name="`display-${field.name}`" :field="field" :value="modelValue[field.name]" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CardInputForm',
  props: {
    title: {
      type: String,
      required: true
    },
    modelValue: {
      type: Object,
      required: true
    },
    fields: {
      type: Array,
      required: true
    }
  }
}
</script>

<style scoped>
.card-input-form {
  background: #FFF;
}

.card-header {
  padding: 16px;
  background-color: var(--content-header-bg);
  border-bottom: var(--content-header-border);
}

.card-title {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: #262626;
}

.card-body {
  padding: 16px;
}

.form-grid {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.form-row {
  display: flex;
  gap: 16px;
  align-items: start;
}

.form-label {
  font-weight: 500;
  color: #333;
  line-height: 31px;
  flex-basis: 200px;
  flex-shrink: 0;
}

.form-field {
  width: 1px;
  flex: 1;
}

.form-editor {
  max-width: 400px;
}

.form-display {
  max-width: 400px;
  color: #333;
  height: 31px;
  display: flex;
  align-items: center;
  padding: 0 2px;
}
</style>
